<template>
  <div>
    <section
      class="about_sec1 about_sec no_banner_page cover"
      v-lazy:background-image="page.acf.page_content[0].img.desktop.url"
    >
      <div class="container">
        <h1 class="cat_title">{{page.title}}</h1>
        <div class="mobile_only about_img_m">
          <img :src="page.acf.page_content[0].img.mobile.url" />
        </div>
        <div class="clearfix">
          <div class="left about_content">
            <h2 class="title">{{page.acf.page_content[0].title}}</h2>
            <div class="title25">{{page.acf.page_content[0].subtitle}}</div>
            <div class="text" v-html="page.acf.page_content[0].content"></div>
          </div>
        </div>
      </div>
      <div class="bn_corner bn_corner-white"></div>
    </section>
    <section
      class="about_sec cover"
      :class="'about_sec'+(index+1)"
      v-for="(row, index) in page.acf.page_content"
      v-if="index > 0"
      :key="index"
      v-lazy:background-image="row.img.desktop.url"
    >
      <div class="mobile_only about_img_m">
        <img :src="row.img.mobile.url" />
      </div>
      <div class="container clearfix">
        <div class="about_content" :class="{left : index%2 == 0 , right: index%2 != 0}">
          <h2 class="title">{{ row.title}}</h2>
          <div class="title25">{{row.subtitle}}</div>
          <div class="text" v-html="row.content"></div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      assets: wpData.assets_url
    };
  },
  computed: {
    page: function() {
      if (typeof wpData.pageData != "object") {
        return JSON.parse(wpData.pageData);
      }
      return wpData.pageData;
    }
  }
};
</script>
